import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Storage as StorageIon } from '@ionic/storage-angular';
import { Observable } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { IStorageKeysObj, IStoragePromise } from 'uInterfaces/storage';
import { Constants } from 'uApp/app.constants';

/*export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => localStorage as Storage,
});*/

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly platformId = inject(PLATFORM_ID);

  private _storage: StorageIon | null = null;
  private storagePref = Constants.STORAGE_PREFIX;
  private mobKeys: IStorageKeysObj = {};
  private secretKey = 'agstorage';

  // constructor(private storage: Storage) {
  constructor(
    // @Inject(BROWSER_STORAGE) private storageBr: Storage,
    private storage: StorageIon
  ) {
    this.init();
  }

  async init() {
    //return new Promise<any>(async (resolve) => {
      try {
        if(isPlatformBrowser(this.platformId)) { console.log('Platform is browser'); }
        if(isPlatformServer(this.platformId)) { console.log('Platform is server'); }
        if (!this._storage) { this._storage = await this.storage.create(); }
      } catch (e) {
        console.log('storage init error:', e);
      }
      // console.log('StorageService:  init done ' + new Date().toLocaleTimeString());
    //  resolve(true);
    //});
  }

  public clearStorage() {
    if (this._storage instanceof Storage) {
      this._storage.clear();
    }
  }

  public getStorageKey(key: string = ''): Observable<any> {
    return new Observable((observer: any) => {
      // console.log('>>>Storage-Utils>>> - getStoredKey 1 start -> key: ', key);
      try {
        if (!this._storage) {
          if(isPlatformBrowser(this.platformId)) { console.log('Platform is browser'); }
          if(isPlatformServer(this.platformId)) { console.log('Platform is server'); }
          this.storage.create().then((storage) => {
            this._storage = storage;
            this.getStorageKeyPromise(key).then(
              (val: any) => {
                // console.log('>>>Storage-Utils>>> - getStoredKey 2 found -> val: ', val);
                if (!val) { val = ''; }
                observer.next(val);
                observer.complete();
              },
              (error: any) => {
                console.log('>>> getStorage_Key >>> 2 onrejected error: ', error);
                observer.error(error);
              });
          });
        } else {
          this.getStorageKeyPromise(key).then(
            (val: any) => {
              // console.log('>>>Storage-Utils>>> - getStoredKey 2 found -> val: ', val);
              if (!val) { val = ''; }
              observer.next(val);
              observer.complete();
            },
            (error: any) => {
              console.log('>>> getStorage_Key >>> 2 onrejected error: ', error);
              observer.error(error);
            });
        }
      } catch (error) {
        console.log('>>> getStorage_Key >>> 3 catch error: ', error);
        observer.error(error);
      }
    });
  }


  public storeKeyObs(keyName: string = '', value: any = null): Observable<any> {
    return new Observable((observer: any) => {
      this.storeKeyCache(keyName, value);
      try {
        if (!this._storage) {
          if(isPlatformBrowser(this.platformId)) { console.log('Platform is browser'); }
          if(isPlatformServer(this.platformId)) { console.log('Platform is server'); }
          this.storage.create().then((storage: StorageIon) => {
            this._storage = storage;
            this.storeKey(keyName, value).then((result: any) => {
              console.log('>>> StorageUtils >>> 2 storeKeyObs - result: ', result);
              observer.next(true);
              observer.complete();
            }).catch((reason: any) => {
              console.log('>>> StorageUtils >>> 3 storeKeyObs - set error: ', reason);
              observer.error(reason);
              observer.complete();
            });
          });
        } else {
          this.storeKey(keyName, value).then((result: any) => {
            console.log('>>> StorageUtils >>> 2 storeKeyObs - result: ', result);
            observer.next(true);
            observer.complete();
          }).catch((reason: any) => {
            console.log('>>> StorageUtils >>> 3 storeKeyObs - set error: ', reason);
            observer.error(reason);
            observer.complete();
          });
        }
      } catch (e) {
        console.log('>>> StorageUtils >>> 4 storeKeyObs - storage ready error: ', e);
      }
    });
  }

  public async storeKey(keyName: string = '', value: any = null): Promise<any> {
    console.log('>>> storeKey >>> keyName: ', keyName, ', value:', value);

    const encryptedData = CryptoJS.AES.encrypt(value, this.secretKey).toString();
    console.log('>>> storeKey >>> encryptedData: ', encryptedData);
    const decryptedData = CryptoJS.AES.decrypt(encryptedData, this.secretKey).toString(CryptoJS.enc.Utf8);
    console.log('>>> storeKey >>> decryptedData: ', decryptedData);

    this.storeKeyCache(keyName, value);
    if (!this._storage) { this._storage = await this.storage.create(); }
    return this._storage.set(this.storagePref+keyName, encryptedData);  //value
  }

  public storeKeyCache(keyName: string = '', value: any) {
    if (keyName !== '') { this.mobKeys[keyName] = value; }
    // console.log('>>> storeKeyCache >>> cache changed: ', this.mobKeys);
  }

  public async getStorageKeyPromise(key: string): Promise<any> {
    if (!this._storage) { this._storage = await this.storage.create(); }
    return this._storage.get(this.storagePref+key).then((value) => {
      return new Promise((resolve) => {
        value = value ?? '';
        const decrypted = CryptoJS.AES.decrypt(value, this.secretKey).toString(CryptoJS.enc.Utf8);
        resolve(decrypted);
      })
    });
  }

  public removeStorageKeyPromise(params: IStoragePromise): Promise<any> | undefined {
    console.log('StorageService: removeStorageKeyPromise - ' + params.key + ', ' + new Date().toLocaleTimeString());
    return this._storage?.remove(this.storagePref+params.key);
  }

  /*get(key: string) {
    return this.storageBr.getItem(key);
  }
  set(key: string, value: string) {
    this.storageBr.setItem(key, value);
  }
  remove(key: string) {
    this.storageBr.removeItem(key);
  }
  clear() {
    this.storageBr.clear();
  }*/
}
